import { useEffect } from 'react'
import { Content } from 'antd/es/layout/layout'
import { Outlet, useLocation } from 'react-router-dom'
import { AppConstant } from 'AppConstant'
import { useLobbyPoll } from 'hooks/useLobbyPoll'
import { useNotesPoll } from 'hooks/useNotesPoll'
import { useShopPoll } from 'hooks/useShopPoll'
import { COLORS } from 'tokens'
import Header from './Header'
import { useMemberCount } from '../../hooks/useMemberCount'
import { useNativeRecordingBridge } from '../../hooks/useNativeRecordingBridge'
import { useSessionTimer } from '../../hooks/useSessionTimer'
import { restoreStudioDetails } from '../../redux/flows/auth/studio'
import { setCurrentScreen } from '../../redux/flows/portal'
import { loadLobbyQueueAsync } from '../../redux/flows/portal/lobby'
import { useAppDispatch, useAppSelector } from '../../redux/store'

const PORTAL_TAB_SCREENS = new Set(['current', 'lobby', 'notes', 'shop', 'schedule'])

export default function PortalLayout() {
  // global poll for notes and lobby
  const dispatch = useAppDispatch()
  const location = useLocation()
  const studioDetails = useAppSelector((state) => state.studioAuth.studioDetails)
  const localStudio = JSON.parse(localStorage.getItem(AppConstant.STUDIO_DETAILS) || '{}')

  useEffect(() => {
    const screen = location.pathname.split('/').filter(Boolean)[0] || 'current'
    if (PORTAL_TAB_SCREENS.has(screen)) {
      dispatch(setCurrentScreen(screen))
    }
  }, [location.pathname, dispatch])

  // Restore studioDetails to Redux state from localStorage if not already in state
  useEffect(() => {
    if (!studioDetails && localStudio?.id) {
      dispatch(restoreStudioDetails())
    }
  }, [studioDetails, localStudio, dispatch])

  useNotesPoll()
  useLobbyPoll()
  useShopPoll()
  useMemberCount()
  useSessionTimer()
  // Listens for native recording events from the Expo shell. Mounted on the
  // layout so it survives when the doctor switches between Lobby/Notes/Schedule
  // tabs - the React Native recorder is global, the listener must be too.
  useNativeRecordingBridge()

  // initial fetch lobby queue on page-refresh
  useEffect(() => {
    const clinicId = studioDetails?.id || localStudio?.id
    if (clinicId) {
      dispatch(loadLobbyQueueAsync({ clinicId }))
    }
  }, [studioDetails, dispatch])

  return (
    <div style={{ height: '100vh', width: '100vw', overflow: 'hidden', touchAction: 'none', WebkitUserSelect: 'none' }}>
      <Header />

      <Content
        style={{
          backgroundColor: COLORS.background,
          paddingLeft: '32px',
          paddingRight: '32px',
          width: '100%',
          overflowY: 'auto',
          overflowX: 'auto',
          height: 'calc(100vh - 128px)',
        }}
      >
        <Outlet />
      </Content>
    </div>
  )
}
